import { Event } from '../../../types/event';
import { Pagination } from '../../../Components/Pagination/Pagination';
import noImage from '../../../Assets/Images/no-img.jpg';
import { ActionMenu } from '../../../Components/ActionMenu/ActionMenu';
import { Link } from 'react-router-dom';
import { Icons } from '../../../Components/Icons/Icons';
import { formatDateRange } from '../../../utils/dateFormatters';
import { useFormatImageUrl } from '../../../utils/formatImageUrl';
import clsx from 'clsx';
import { UserRole } from '../../../api/users';
import { useAuth } from '../../../contexts/AuthContext';

interface EventsContentProps {
  eventsData: {
    events: Event[];
    totalPages: number;
  };
  currentPage: number;
  onPageChange: (page: number) => void;
  onDeleteEvent: (id: string) => void;
  onEditEvent: (eventItem: Event) => void;
}

export const EventsContent: React.FC<EventsContentProps> = ({
  eventsData,
  currentPage,
  onPageChange,
  onDeleteEvent,
  onEditEvent,
}) => {
  const formatImageUrl = useFormatImageUrl();
  const { userData } = useAuth();

  const handleDelete = async (id: string) => {
    await onDeleteEvent(id);
  };

  if (eventsData.events.length === 0) {
    return <div className="no-data-message">No events found</div>;
  }

  return (
    <div className="events-content">
      <div className="events__list">
        {eventsData.events.map((event) => {
          const imageUrl = formatImageUrl(event.image);

          return (
            <Link
              to={`/events/${event.id}`}
              key={event.id}
              className={clsx('events__item')}
              onClick={(e) => {
                if ((e.target as HTMLElement).closest('.card-menu, .menu-trigger')) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }}
            >
              {userData?.role === UserRole.ADMIN && (
                <ActionMenu
                  onEdit={() => onEditEvent(event)}
                  onDelete={() => handleDelete(event.id)}
                />
              )}
              <div className="event-image">
                <img
                  src={imageUrl}
                  alt={event.name}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = noImage;
                  }}
                />
              </div>
              <div className="content">
                <div className="date">{formatDateRange(event.startDate, event.endDate)}</div>
                <h3>{event.name}</h3>
                <p>{event.description}</p>
                <span className="learn-more">
                  Learn More
                  {Icons.ArrowRight}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
      {eventsData.totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={eventsData.totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
};
